import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Svg from '../../common/components/Svg';

import chevron from '../../common/assets/icons/chevron-right.svg';

import styles from './split-images.scss';

const SplitImages = ({ leftImage, leftText, leftLink, rightImage, rightText, rightLink }) => (
  <div className={styles.splitImages}>
    <Link to={leftLink} className={styles.image}>
      <div
        className={styles.backgroundImage}
        style={{ backgroundImage: `url('${leftImage}')` }}
      />
      <div className={styles.imageText}>
        {leftText} <Svg src={chevron} className={styles.chevron} />
      </div>
    </Link>
    <Link to={rightLink} className={styles.image}>
      <div
        className={styles.backgroundImage}
        style={{ backgroundImage: `url('${rightImage}')` }}
      />
      <div className={styles.imageText}>
        {rightText} <Svg src={chevron} className={styles.chevron} />
      </div>
    </Link>
  </div>
);

SplitImages.propTypes = {
  leftImage: PropTypes.string.isRequired,
  leftText: PropTypes.string.isRequired,
  leftLink: PropTypes.string.isRequired,
  rightImage: PropTypes.string.isRequired,
  rightText: PropTypes.string.isRequired,
  rightLink: PropTypes.string.isRequired,
};

export default SplitImages;



// WEBPACK FOOTER //
// ./blocks/SplitImages/index.js